import { useState } from 'react';
import { caseList } from '@/mocks/blackMaterial';
import Reveal from './Reveal';
import SectionHeading from './SectionHeading';

const STATUS = ['全部', '实锤', '跟进中'] as const;

export default function CaseArchive() {
  const [status, setStatus] = useState<(typeof STATUS)[number]>('全部');
  const list = status === '全部' ? caseList : caseList.filter((c) => c.status === status);

  return (
    <section id="shichui" className="scroll-mt-28 border-y border-[#e0d6c6] bg-[#efe7d7]/70">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-16">
        <div className="grid gap-8 lg:grid-cols-12">
          {/* 左侧索引 */}
          <div className="lg:col-span-4">
            <Reveal>
              <div className="lg:sticky lg:top-32">
                <SectionHeading
                  kicker="WHAT · 事件扒皮"
                  title="事件实锤 · 专题归档"
                  desc="同一事件的全部公开证据收进一个专题，按时间线铺开。红色盖章为已核实实锤，琥珀色仍在跟进核实。"
                />
                <div className="flex flex-wrap items-center gap-2">
                  {STATUS.map((s) => (
                    <button
                      key={s}
                      onClick={() => setStatus(s)}
                      className={`cursor-pointer rounded-full px-4 py-1.5 text-xs font-semibold transition ${
                        status === s ? 'bg-[#c83424] text-white' : 'bg-white text-[#6b5f51] ring-1 ring-[#e0d6c6]'
                      }`}
                    >
                      {s}
                    </button>
                  ))}
                </div>

                <div className="mt-6 rounded-lg bg-white p-4 ring-1 ring-[#e6dbc9]">
                  <p className="text-xs font-bold tracking-wide text-[#262019]">本周专题进展</p>
                  <ul className="mt-3 space-y-2.5 text-xs text-[#5d5245]">
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill mt-0.5 text-[#c83424]"></i>
                      新增实锤专题 4 个，完成信源交叉核对
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-loader-4-line mt-0.5 text-[#9a6b13]"></i>
                      3 个「跟进中」事件正在补全现场证词
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-up-down-line mt-0.5 text-[#9a6b13]"></i>
                      6 条勘误已复核并入勘误页
                    </li>
                  </ul>
                </div>
              </div>
            </Reveal>
          </div>

          {/* 右侧事件列表 */}
          <div className="space-y-4 lg:col-span-8">
            {list.map((c, idx) => (
              <Reveal key={c.id} delay={idx * 50}>
                <article className="group rounded-lg bg-white p-4 ring-1 ring-[#e6dbc9] transition hover:ring-[#c83424] md:p-5">
                  <div className="flex flex-wrap items-center gap-2">
                    <span
                      className={`flex items-center gap-1 rounded px-2 py-0.5 text-[11px] font-bold ${
                        c.status === '实锤' ? 'bg-[#fdeee9] text-[#b0392a]' : 'bg-[#fbf3e0] text-[#9a6b13]'
                      }`}
                    >
                      <i className={c.status === '实锤' ? 'ri-verified-badge-fill' : 'ri-timer-flash-line'}></i>
                      {c.status}
                    </span>
                    <span className="rounded-full bg-[#f0e8d8] px-2.5 py-0.5 text-[11px] font-medium text-[#6b5f51]">
                      {c.field}
                    </span>
                    <span className="ml-auto flex items-center gap-1 text-[11px] text-[#9a8a75]">
                      <i className="ri-calendar-line"></i>{c.date}
                      <span className="ml-2 flex items-center gap-1 text-[#b0392a]">
                        <i className="ri-fire-fill text-[#e8603c]"></i>{c.hot}
                      </span>
                    </span>
                  </div>

                  <h3 className="font-display mt-3 text-lg font-extrabold text-[#262019] transition group-hover:text-[#b0392a] md:text-xl">
                    {c.title}
                  </h3>

                  <ol className="mt-4 grid gap-2 border-l-2 border-[#eadfd0] sm:grid-cols-3">
                    {c.points.map((p, pi) => (
                      <li key={p} className="relative pl-5 text-[13px] leading-5 text-[#5d5245]">
                        <span className="absolute -left-[5px] top-1.5 h-2 w-2 rounded-full bg-[#c83424] ring-2 ring-white"></span>
                        <span className="mb-1 block text-[10px] font-bold text-[#c9bdab]">要点 {pi + 1}</span>
                        {p}
                      </li>
                    ))}
                  </ol>

                  <div className="mt-4 flex flex-wrap items-center gap-3 border-t border-[#eadfd0] pt-3 text-xs">
                    <span className="flex cursor-pointer items-center gap-1 font-semibold text-[#c83424]">
                      进入专题 · 证据编号全览 <i className="ri-arrow-right-line"></i>
                    </span>
                    <span className="flex items-center gap-1 text-[#9a8a75]">
                      <i className="ri-file-copy-line"></i>证据 8 份
                    </span>
                    <span className="flex items-center gap-1 text-[#9a8a75]">
                      <i className="ri-message-3-line"></i>讨论 231
                    </span>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}